module.exports = __webpack_public_path__ + "img/source_sw-item4.9027de8c.png";